import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fmtFloatNum } from '../../../utils';

const Total = ({ prod, wrapped }) => {
  const { amounts } = useSelector((state) => state.prod);

  const { id, showPromoPrice, promoPrice, price } = prod;
  const currPrice = showPromoPrice ? promoPrice : price;

  let { multiplier } = prod;
  multiplier = Number(multiplier);

  const [total, setTotal] = useState(multiplier * currPrice);
  const [fmt, setFmt] = useState(fmtFloatNum(multiplier * currPrice));
  const [cssClass, setCssClass] = useState('by-default');

  useEffect(() => {
    const newAmount = amounts[id] ? amounts[id] : multiplier;
    setTotal(newAmount * currPrice);
  }, [id, amounts, currPrice, setTotal]);

  useEffect(() => {
    const newCssClass = `c-${fmt.length}`;
    setCssClass(newCssClass);
  }, [fmt, setCssClass]);

  useEffect(() => {
    setFmt(fmtFloatNum(total));
  }, [total, setFmt]);

  return (
    <>
      {!wrapped && <>{fmt}</>}
      {wrapped && <div className={cssClass}>{fmt}</div>}
    </>
  );
};

export default Total;
